var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"tr item-tr"},[_c('td',{staticClass:"td item-td __name"},[_c('div',{staticClass:"item-tr-name"},[_c('UserAvatar',{attrs:{"user":_vm.log.user,"size":`44px`}}),_c('span',[_vm._v(_vm._s(_vm.log.user.artisticName || _vm.log.user.name))])],1)]),_c('td',{staticClass:"td item-td __count"},[_vm._v(_vm._s(_vm.log.count + " Veces"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }